export default __webpack_public_path__ + "static/Calendar-2016 -20-6fdc637958e8ea2933dc423b2dffa5cc.jpg";